/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="13.24"
        height="18.9"
        viewBox="0 0 13.24 18.9"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m0 0 2.23 9.06a5.81 5.81 0 0 0-1.52 3.93 5.92 5.92 0 1 0 10.3-3.93L13.24 0Zm8.25 1L7.7 7.2a5.49 5.49 0 0 0-1.08-.1h-.06a4.87 4.87 0 0 0-.76.06h-.25L4.99.96Zm-7 0h2.71l.58 6.47-.14.05a6.48 6.48 0 0 0-1.36.76Zm10.26 12a4.92 4.92 0 0 1-9.83 0 4.77 4.77 0 0 1 1.07-3l.38-.43.17-.16a4.16 4.16 0 0 1 .39-.32c.1-.07.2-.15.32-.22a5.33 5.33 0 0 1 .57-.31l.17-.07h.09a5.53 5.53 0 0 1 .66-.2h.15a5.63 5.63 0 0 1 .92-.1h.18a6 6 0 0 1 .61.06 5.57 5.57 0 0 1 2.38 1.09l.07.06.1.08.16.14.07.08a4.88 4.88 0 0 1 1.37 3.36Zm-1.37-4.71a5.8 5.8 0 0 0-1.49-.8l.57-6.48h2.71Zm-3.55.7L5.4 11.47l-2.67.33 2 1.76-.77 3.06L6.59 15l2.63 1.62-.77-3.06 2-1.76-2.58-.33Zm1.06 5.47-1.06-.65-1.06.65.32-1.27-.8-.69 1-.13.57-1.13.56 1.13 1 .13-.8.69Z"
          className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'AchievementMedalIcon';

export default Icon;
